import { ERROR_TITLE, FETCH_ERROR } from '../constants';
import { ErrorMessage, ErrorRoot, ErrorTitle, RetryButton } from './styled';
import type { ErrorStateProps } from './types';

const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
  <ErrorRoot role="alert">
    <ErrorTitle>{ERROR_TITLE}</ErrorTitle>
    <ErrorMessage>{message?.trim() || FETCH_ERROR}</ErrorMessage>
    {onRetry ? (
      <RetryButton variant="outlined" size="small" onClick={onRetry}>
        Retry
      </RetryButton>
    ) : null}
  </ErrorRoot>
);

export default ErrorState;
